<div class="attritionCard">
    <div>
        <!-- <div class="profilepic">
            <i class="fa-solid fa-user"></i>
        </div> -->
        <div>
            <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="{
                'lavender-circle': i % 4 == 0,
                'yellow-circle': i % 4 == 1,
                'blue-circle': i % 4 == 2,
                'teal-circle': i % 4 == 3
              }">{{transform(candidateDetails?.full_name).charAt(0)}}</div>
        </div>
    </div>
    <div>
        <p class="f-14 font-weight-600 mb-1 d-grid" *ngIf="candidateDetails?.full_name">
            <span class="text-truncate" [matTooltip]="candidateDetails?.full_name | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.full_name | titlecase}}</span>
        </p>
        <p class="f-14 mb-1 d-grid" *ngIf="candidateDetails?.job_title">
            <span class="text-truncate" [matTooltip]="candidateDetails?.job_title | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{candidateDetails?.job_title | titlecase}}</span>
        </p>
        <div class="f-12 text-9696 d-flex align-items-center">
            <span class="d-flex align-items-baseline" *ngIf="currentLocation">
                <i class="fa-regular fa-location-dot mr-1"></i>
                <div class="d-grid">
                    <span class="text-truncate" [matTooltip]="currentLocation | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">
                        {{currentLocation | titlecase}}
                    </span>
                </div>
            </span>
            <i class="fa-solid fa-circle mx-2" style="font-size:3px; color: #d9d9d9; margin-top: 0px;" *ngIf="currentLocation && (candidateDetails?.linkedin_url || candidateDetails?.twitter_url || candidateDetails?.facebook_url)"></i>
            <span class="d-flex" style="width: 55px;">
                <a data-testid="auto-app-candidate-card-view-a-1" target="_blank" rel="noopener noreferrer" *ngIf="candidateDetails?.linkedin_url && !isBoolean(candidateDetails?.linkedin_url)" (click)="openUrl(candidateDetails?.linkedin_url, 'linkedin')"><i class="fab fa-linkedin"></i></a>
                <a data-testid="auto-app-candidate-card-view-a-2" target="_blank" rel="noopener noreferrer" *ngIf="candidateDetails?.twitter_url && !isBoolean(candidateDetails?.twitter_url)" (click)="openUrl(candidateDetails?.twitter_url, 'twitter')"><i class="fa-brands fa-square-x-twitter mx-2"></i></a>
                <a data-testid="auto-app-candidate-card-view-a-3" target="_blank" rel="noopener noreferrer" *ngIf="candidateDetails?.facebook_url && !isBoolean(candidateDetails?.facebook_url)" (click)="openUrl(candidateDetails?.facebook_url, 'facebook')"><i class="fab fa-facebook"></i></a>
            </span>
        </div>
    </div>
</div>
